var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeactivate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_75758",
    "data-name": "Path 75758",
    d: "M1119,888h2a1.784,1.784,0,0,0,.24.051,15.228,15.228,0,0,1,6.733,2.084,15.794,15.794,0,0,1,7.781,11.108c.109.581.165,1.171.246,1.757v2a1.785,1.785,0,0,0-.052.241,15.416,15.416,0,0,1-2.611,7.582,15.779,15.779,0,0,1-10.551,6.928c-.59.11-1.191.167-1.786.248h-2a1.814,1.814,0,0,0-.24-.052,16.02,16.02,0,0,1-14.521-13.222c-.1-.571-.161-1.151-.239-1.726v-2c.025-.2.053-.409.075-.615a16.028,16.028,0,0,1,13.2-14.144C1117.846,888.142,1118.424,888.079,1119,888Zm7.93,6.205a11.984,11.984,0,0,0-16.711,16.711Zm2.869,2.881L1113.087,913.8a11.987,11.987,0,0,0,16.711-16.711Z",
    transform: "translate(-1104 -888)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivate);
export default __webpack_public_path__ + "static/media/Deactivate.377daf8840efb0a8504c35fba51b3e5e.svg";
export { ForwardRef as ReactComponent };